import { Order, PartnerConfig } from '@/types';
import { Eligibility } from '@/types/Eligibility';

import { matchCobrandedPartner } from '../configs/cobrandedPartners';

const getCobrandedConfig = (
  orderOrEligibility?: Order | Eligibility,
): PartnerConfig | undefined => matchCobrandedPartner(orderOrEligibility);

export default getCobrandedConfig;
